import { render, staticRenderFns } from "./profile-booking-requests.vue?vue&type=template&id=b5d96ffa&scoped=true&"
import script from "./profile-booking-requests.ts?vue&type=script&lang=ts&"
export * from "./profile-booking-requests.ts?vue&type=script&lang=ts&"
import style0 from "./profile-booking-requests.scss?vue&type=style&index=0&id=b5d96ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d96ffa",
  null
  
)

export default component.exports